import { Control, Controller } from 'react-hook-form';

import { USER_SEX, UserSex } from '@data';
import { useTranslate } from '@i18n';
import { Select, Stack, Text, u } from '@ui';

import { UserWelcomeWizardForm } from '../useUserWelcomeWizard';

type SexStepProps = {
    control: Control<UserWelcomeWizardForm>;
};

const NO_SELECTION = 'NONE';

const toSexValue = (value: string | undefined): UserSex | null =>
    value && value !== NO_SELECTION ? (value as UserSex) : null;

export const SexStep = ({ control }: SexStepProps) => {
    const t = useTranslate();
    const options = [
        {
            value: NO_SELECTION,
            label: t('user_welcome_wizard.sex_options_prefer_not_to_say_title'),
        },
        {
            value: USER_SEX.MALE,
            label: t('user_welcome_wizard.sex_options_male_title'),
        },
        {
            value: USER_SEX.FEMALE,
            label: t('user_welcome_wizard.sex_options_female_title'),
        },
        {
            value: USER_SEX.OTHER,
            label: t('user_welcome_wizard.sex_options_other_title'),
        },
    ];

    return (
        <Controller
            control={control}
            name="sex"
            render={({ field }) => (
                <Stack gap={u(1)}>
                    <Select
                        options={options}
                        selectedValue={field.value ?? undefined}
                        onChange={(values) => field.onChange(toSexValue(values[0]))}
                        label={t('user_settings.sex_label')}
                        placeholder={t('user_settings.sex_label')}
                        width="100%"
                    />
                    <Text variant="pSmall" color="muted">
                        {t('user_welcome_wizard.sex_optional')}
                    </Text>
                </Stack>
            )}
        />
    );
};
